import { ResourceLanguage } from 'i18next';

import { apiTranslation } from './api';
import { authTranslation } from './auth';
import { feedbackTranslation } from './feedback';
import { formTranslation } from './form';
import { termsTranslation } from './terms';

const translation: ResourceLanguage = {
  company: 'Empresa',
  candidate: 'Candidato',
  job: 'Vaga',
  auth: authTranslation,
  form: formTranslation,
  terms: termsTranslation,
  feedback: feedbackTranslation,
  api: apiTranslation,
};

export default translation;
